import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import DateControl from "../../../components/Fields/DateControl";
import Field from "../../../components/Fields/Field";
import FieldLabel from "../../../components/Fields/FieldLabel";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import ProjectStatusModel from "../../../models/ProjectStatusModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";
import FormatUtils from "../../../utils/FormatUtils";

const CreateProjectStatusPopup: React.FC<PopupProps> = ({ show, onHide }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<ProjectStatusModel|undefined>({
        id: 0,
        name: '',
        beginDate: new FormatUtils().formatDateForStorage(new Date()),
        endDate: '',
        concurrencyId: ''
    });

    function submit() {
        if (formData) {
            DataService
                .create<number>(`api/v1/projectstatuses/`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && onHide)
                        onHide()
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'name', label: 'Name', validationRules: [{ type: 'isRequired' }] },
            { name: 'beginDate', label: 'Active from', validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
            { name: 'endDate', label: 'Active Until', labelSize: 'auto', validationRules: [{ type: 'isDate' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getLabelProps, getControlProps, getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Create project status'} >
            <Popup.Body>
                <TextboxField {...getFieldProps('name')} />
                <Field {...getLabelProps('beginDate')}>
                    <DateControl {...getControlProps('beginDate')} />
                    <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('endDate')} /></span>
                    <DateControl {...getControlProps('endDate')} />
                </Field>            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Create' />
            </Popup.Footer>
        </Popup>
    );
}
export default CreateProjectStatusPopup;

